import './errorboundary.css';

import { BiError } from "react-icons/bi";
import { useNavigate } from 'react-router-dom';
export default function Fallback({ error, resetErrorBoundary }) {
  
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    navigate('/', { replace: true});
  }

  return (
    <div className="erro-container">
      <div className="icone-erro">
        <BiError/>
      </div>
      <h2>Parece que ocorreu um problema inesperado..</h2>
      <p>Se o erro persistir clique em logout para sair do sistema.</p>
      <p className="mensagem-erro">{error.message}</p>
      <button className="btn btn-sm btn-danger me-2" onClick={resetErrorBoundary}>
        Tentar Novamente
      </button>
      <button className="btn btn-sm btn-secondary" onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
}
